import type { ReactNode } from 'react';

export const symbol_trail_length_short: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M600-280q-73 0-129-46.5T402-450H190q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h211.81Q407-542 422-571.5t37-48.5H270q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h330q83 0 141.5 58.5T800-480q0 83-58.5 141.5T600-280Zm-.24-60Q658-340 699-380.76q41-40.77 41-99Q740-538 699.24-579q-40.77-41-99-41Q542-620 501-579.24q-41 40.77-41 99Q460-422 500.76-381q40.77 41 99 41ZM310-280q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h60q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-60Zm290-200Z"
		/>
	</svg>
);
